import { render } from "./BasicInfoPage.vue?vue&type=template&id=4fc4a7c0"
import script from "./BasicInfoPage.vue?vue&type=script&lang=js"
export * from "./BasicInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__